import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsService, StorageService, UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-otd-cartdrop',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './otd-cartdrop.component.html',
  styleUrls: ['./otd-cartdrop.component.scss']
})
export class OtdCartdropComponent implements OnInit {

  cartData: any;

  constructor(
    public storage: StorageService,
    public util: UtilService,
    public events: EventsService
  ) {}

  ngOnInit() {
    this.util.vars.abondenedCart.next(this.storage.get('abandonedCartOtd'));
    this.util.vars.abondenedCart.subscribe(res => {
      this.cartData = res;
    });
  }

  redirect() {
    const payload = {
      eventName: 'Click_on_donate',
      info_1: 'Drop_cart'
    };
    this.storage.deleteFromSession('donateOpened-'+this.cartData?.fundraiser?.custom_tag);
    this.util.router.navigate([this.cartData?.link], { queryParams: { donate: 1 }, queryParamsHandling: 'merge'}).then(() => {
      this.events.sendSystemEvent(payload).subscribe(_ => _);
    });
  }

  close() {
    this.events.sendSystemEvent({
      eventName: 'close_cart'
    }).subscribe(_ => _);
    this.util.vars.abondenedCart.next(null);
    this.storage.delete('abandonedCartOtd');
  }

}
